var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V10H2V6Z",
    fill: "#6C65F7",
    fillOpacity: 0.16
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 4.5,
    width: 19,
    height: 16,
    rx: 1.5,
    stroke: "#6C65F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 20,
    height: 1,
    fill: "#6C65F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 2,
    height: 2,
    rx: 0.2,
    fill: "#6C65F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 2,
    height: 2,
    rx: 0.2,
    fill: "#6C65F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 2,
    height: 2,
    rx: 0.2,
    fill: "#6C65F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 2,
    width: 1,
    height: 5,
    rx: 0.2,
    fill: "#6C65F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2,
    width: 1,
    height: 5,
    rx: 0.2,
    fill: "#6C65F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 2,
    width: 1,
    height: 5,
    rx: 0.2,
    fill: "#6C65F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActive);
export default __webpack_public_path__ + "static/media/calendar-active.e37915b4757c7c3d9343048b89b81488.svg";
export { ForwardRef as ReactComponent };